import styled from 'styled-components';

export const FormContainer = styled.div`
  padding: 16px;
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
`;
